
   
<div style="display: block;">
    <canvas baseChart 
      [data]="pieChartData" 
      [labels]="pieChartLabels" 
      [type]="pieChartType"
      [options]="pieChartOptions"
      [legend]="pieChartLegend"
      #chartCanvas
      >
    </canvas>
  </div>